import React from 'react';
import { jwtDecode } from 'jwt-decode';
import PageForm from "components/pageForm";
import UseContext from "hooks/useContext";

const Dashboard = () => {
    const { companyData } = UseContext();

    const getUserId = () => {
        const token = localStorage.getItem('xsrfToken');
        if (!token) return '';
        try {
            const decoded = jwtDecode(token);
            return decoded?.id || '';
        } catch {
            return '';
        }
    };

    const userId = getUserId();
    const companyId = companyData?._id || '';
    const retoolUrl = companyId
        ? `https://jobbiz.retool.com/embedded/public/020f3b9e-6d09-4baa-aa75-b7c8b3eedcae?userId=${userId}&companyId=${companyId}`
        : '';

    return (
        <PageForm>
            <div className="h-full w-full flex flex-col">
                {retoolUrl ? (
                    <iframe
                        src={retoolUrl}
                        width="100%"
                        height="100%"
                        style={{ border: 'none', flex: 1 }}
                        title="Tableau de bord Retool"
                    />
                ) : (
                    <div className="flex items-center justify-center flex-1">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
                    </div>
                )}
            </div>
        </PageForm>
    );
};

export default Dashboard;